module.exports = __webpack_public_path__ + "img/PT7.0ae99fc9.png";